const isString = (value) => {
  return typeof value === "string";
};

export default isString;
